module.exports = __webpack_public_path__ + "media/msg.cd351bbe.mp3";